export const config = {
  title: "Hernandez Landscaping | Austin, TX | Professional Landscaping Services",
  meta: {
    description:
      "Hernandez Landscaping offers professional landscaping services in Austin, TX with 15 years of experience. Specializing in landscape installation, tree trimming, turf installation, and fence installation. Serving residential and commercial properties within a 40-mile radius.",
    keywords: [
      "Hernandez Landscaping",
      "Austin Landscaping",
      "Landscape Installation Austin TX",
      "Tree Trimming Austin",
      "Turf Installation",
      "Fence Installation Austin",
      "Austin Landscaping Services",
      "Residential Landscaping Austin"
    ],
    author: "Hernandez Landscaping",
    canonicalUrl: "https://hernandezlandscapingtx.com/",
  },
  sections: {
    header: {
      businessName: "Hernandez Landscaping",
    },
    sectionB: {
      heroTitle: "Transform Your Outdoor Space Into a Beautiful Oasis",
      heroSubtitle: "Professional Landscaping Services in Austin, TX - 15 Years of Excellence",
      learnAboutText: "Get 10% Off Your First Service",
      phoneNumber: "5127431256",
      phoneLabel: "(512) 743-1256",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1558904541-efa843a96f01?w=1200&q=80",
      cardData: [
        {
          title: "Landscape Installation",
          description:
            "Complete landscape design and installation services to create your dream outdoor space.",
        },
        {
          title: "Tree Trimming Service",
          description:
            "Professional tree care and trimming to maintain healthy, beautiful trees year-round.",
        },
        {
          title: "Turf & Fence Installation",
          description:
            "Expert installation of natural turf, artificial grass, and vinyl fencing solutions.",
        },
      ],
      description:
        "With 15 years of experience, Hernandez Landscaping provides full-service landscaping solutions in Austin, TX. From initial consultation to final cleanup, we understand the specific climate challenges and soil conditions unique to this region.",
    },
    sectionC: {
      servicesTitle: "Our Landscaping Services",
      servicesDescription:
        "Comprehensive landscaping solutions for residential and commercial properties. We offer certified practices and service warranties, ensuring durable results that enhance both functionality and aesthetics.",
      cards: [
        {
          title: "Landscape Installation",
          description:
            "Complete landscape design and installation with thoughtful planning, quality materials, and expert execution tailored to Austin's climate.",
          imageSrc: "https://images.unsplash.com/photo-1558904541-efa843a96f01?w=600&q=80",
          imageAlt: "Professional landscape installation",
        },
        {
          title: "Tree Trimming Service",
          description:
            "Professional tree care, trimming, and maintenance to keep your trees healthy, safe, and beautifully shaped throughout the seasons.",
          imageSrc: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=600&q=80",
          imageAlt: "Tree trimming and care",
        },
        {
          title: "Turf Installation",
          description:
            "High-quality natural and artificial turf installation for lawns, play areas, and commercial spaces with long-lasting results.",
          imageSrc: "https://images.unsplash.com/photo-1592595896551-12b371d546d5?w=600&q=80",
          imageAlt: "Turf installation service",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Vinyl Fence Installation",
        "Fence Repair",
        "Mulching",
        "Artificial Grass Installation",
        "Gravel Delivery and Spreading",
        "General Repairs",
      ],
    },
    sectionD: {
      aboutTitle: "Why Choose Hernandez Landscaping?",
      aboutImage: {
        src: "https://hernandezlandscapingtx.com/wp-content/uploads/2025/09/Reliable-landscaping-services.webp",
        alt: "Hernandez Landscaping team",
      },
      aboutText: [
        "Hernandez Landscaping brings 15 years of experience to every project in the Austin, TX area. We understand the specific climate challenges and soil conditions unique to this region, allowing us to deliver landscaping solutions that thrive year-round.",
        "Unlike unreliable contractors who leave projects incomplete, we provide full-service support from initial consultation to final cleanup. Our physical shop serves as a local point of trust, and our certifications and service warranties give customers complete peace of mind.",
        "We center our services around reliability, communication, and respect for your investment. With careful planning, proven materials, and transparent processes, we create durable outdoor spaces that boost curb appeal, reduce maintenance costs, and add lasting value to your property. Serving both residential and commercial clients within a 40-mile radius of Austin.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Hernandez Landscaping Logo",
      businessName: "Hernandez Landscaping",
      contact: {
        phone: "5127431256",
        phoneLabel: "(512) 743-1256",
        email: "chapulinhernandez1@gmail.com",
        website: "https://hernandezlandscapingtx.com/",
        address: "Austin, TX 78734",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Austin, TX 78734",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27716.234!2d-97.8907!3d30.3878!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865b4d4f0e5d4c5f%3A0x1234567890abcdef!2sAustin%2C%20TX%2078734!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;